import {useAuthStore} from '../store';

export const getUserId = () => {
  const {user} = useAuthStore.getState();
  return user?._id || '';
};

export const getInitials = (name = '') =>
  name
    .split(' ')
    .map((s) => s[0]?.toUpperCase())
    .join('');
